import React from "react";
import { Table, Tag, Typography, Switch } from "@arco-design/web-react";

const { Text, Paragraph } = Typography;

const PURPOSE = {
  dkim: "Lets Amazon sign your mail as your domain (DKIM)",
  ownership: "Shows this domain is yours",
  mail_from_mx: "Bounces come back through Amazon (SPF)",
  mail_from_spf: "Allows Amazon to send for the bounce address (SPF)",
  dmarc: "Tells mail providers what to do with mail that fails the checks (DMARC)",
};

function StatusTag({ record }) {
  if (record.status === "ok") return <Tag color="green">Found</Tag>;
  if (record.status === "failed") return <Tag color="red">Failed</Tag>;
  if (record.strongly_recommended) return <Tag color="orange">Strongly recommended</Tag>;
  if (!record.required) return <Tag>Recommended</Tag>;
  return <Tag color="orange">Not found yet</Tag>;
}

// The DNS records an org adds for its sending domain, with copy buttons and
// whether each has been found yet. controls go next to its own switch, e.g.
// the walkthrough's "Show as a table".
export default function DnsRecordsTable({ records, controls }) {
  const [fullNames, setFullNames] = React.useState(false);
  const columns = [
    { title: "Type", dataIndex: "type", width: 70 },
    {
      title: fullNames ? "Name" : "Host",
      render: (_, r) => <Text copyable>{fullNames ? r.name : r.host}</Text>,
    },
    {
      title: "Value",
      render: (_, r) => (
        <div>
          <Text copyable style={{ wordBreak: "break-all" }}>{r.value}</Text>
          <div style={{ fontSize: 12, color: "var(--color-text-3)" }}>{PURPOSE[r.purpose]}</div>
        </div>
      ),
    },
    { title: "Priority", render: (_, r) => (r.priority ? r.priority : ""), width: 80 },
    { title: "Status", render: (_, r) => <StatusTag record={r} />, width: 130 },
  ];
  return (
    <div>
      <Paragraph type="secondary" style={{ fontSize: 13 }}>
        Add these at the company that manages your domain's DNS. Most DNS screens add your domain
        to the name for you, so enter the <b>Host</b>; if yours wants the whole name, switch on
        full names. Changes can take from a few minutes to a few hours to show up.
        {" "}If you already have a DMARC record, keep it: don't add a second one.
      </Paragraph>
      <div style={{ marginBottom: 8, display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
        {controls}
        <Switch size="small" checked={fullNames} onChange={setFullNames} />
        <Text type="secondary" style={{ fontSize: 13 }}>Show full names</Text>
      </div>
      <Table size="small" columns={columns} data={records || []} rowKey={(r) => r.purpose + r.name + r.value} pagination={false} border={false} />
    </div>
  );
}
